import React from 'react';
import { Path } from 'app/const/Path';
import { Link } from 'react-router-dom';
import { Box, Container, Grid } from '@material-ui/core';
import { FilledButton } from 'app/components/Buttons/FilledButton';
import {
  uncoverButtonsCss,
  uncoverDataCss,
} from 'app/modules/web-shop/sub-modules/landing-module/components/UncoverData-block/style';
import { ReactComponent as UncoverDataImg } from 'app/modules/web-shop/sub-modules/landing-module/components/UncoverData-block/uncoverData.svg';

export default function UncoverDataBlock() {
  return (
    <div
      css={`
        background-color: #ffffff;

        @media (max-width: 962px) {
          background-color: #fff;
        }
      `}
    >
      <Container maxWidth="lg" css={uncoverDataCss}>
        <Grid container spacing={8}>
          <Grid item xs={12} md={5} lg={6}>
            <Box height={9} />
            <h2>Easily Uncover Data with AIDA</h2>
            <p>
              Navigate the open aid data landscape effortlessly on the <br />{' '}
              AIDA platform. Leverage intelligent filters to pinpoint <br />{' '}
              precisely what you&apos;re seeking.
            </p>
            <p>
              Visualize all IATI data at your fingertips through interactive{' '}
              <br />
              visualizations, making data-driven decision-making a breeze.{' '}
              <br /> Build custom summaries by saving your search results.{' '}
              <br /> Quickly gain a thorough understanding of aid information.
            </p>
            <div
              css={`
                ${uncoverButtonsCss}/* @media (max-width: 962px) {
                  display: none;
                } */
              `}
            >
              <Link
                to={{
                  pathname: Path.basePath,
                  state: 1,
                }}
              >
                <FilledButton label="Start Exploring" />
              </Link>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={6}>
            <UncoverDataImg
              css={`
                width: 678px;
                height: 451px;
                @media (max-width: 600px) {
                  height: 306px;
                }
              `}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
